import { useAppDispatch, useAppSelector } from "./typed-hooks";
import {
  radiologistUserObject,
  radiologistToken,
  IUserObject,
} from "./../slices/radiologist-user";
import {
  IDeptObject,
  radiologyDeptToken,
  radiologyDeptUserObject,
  updateDeptUser,
} from "../slices/radiology-dept.slice";
import { studyStats } from "../slices/study-stats.slice";
import { tranXStats } from "../slices/tranXstats.slice";
import { useEffect } from "react";
import { getOrg } from "../services/get-user";
import { getCookie } from "../utils/cookies";


// This gets the radiologist user object and access token
export const useGetUserFromStore = () => {
  const userObject: IUserObject = useAppSelector(radiologistUserObject);
  const accessToken = useAppSelector(radiologistToken);

  return {
    userObject,
    accessToken,
  };
};

// This gets the radiology department user object and access token
export const useGetDeptFromStore = () => {
  const userObject: IDeptObject = useAppSelector(radiologyDeptUserObject);
  const accessToken = useAppSelector(radiologyDeptToken);
  // console.log( "Access token", accessToken)
  const dispatch = useAppDispatch();
  // const gyCookie = getCookie("gy") as { user: { orgId: string } };

  const getOrgDataFromApi = async () => {
    const orgDataResponse = await getOrg(userObject?.orgId, accessToken);
    // console.log("origgigigig", orgDataResponse);

    if (orgDataResponse?.data) {
      dispatch(updateDeptUser(orgDataResponse?.data));
    }
  };

  useEffect(() => {
    getOrgDataFromApi();
  }, []);

  return {
    userObject,
    accessToken,
  };
};



export const useGetStudyStatsFromStore = () => {
  const stats = useAppSelector(studyStats);
  return stats;
};

export const useGetTranXStats = () => {
  const stats = useAppSelector(tranXStats);
  return stats;
};
